import { Button, Spinner } from '@ws/shared/components';
import { Close20 } from '@ws/shared/icons';
import { ITkMarkerRef } from '@ws/shared/utils';
import { classes } from 'classifizer';

import { TTkMarkersState } from '../types';

import styles from './TkPanelView.module.css';

export interface ITkPanelViewProps {
  state: TTkMarkersState;

  onClose(): void;

  onMarkerClick(marker: ITkMarkerRef): void;
}

/**
 * Панель показывает ЧЕТЫРЕ разных состояния, и путать их нельзя.
 *
 * «Считаем» и «меток нет» — разные вещи: пустой экран во время счёта прочитался
 * бы как «всё дописано». «Меток нет» и «часть заметок не загрузилась» — тоже
 * разные: во втором случае ноль ничего не значит, и говорить о нём как о нуле
 * значит врать. Ради доверия к этому числу панель и существует.
 */
export function TkPanelView({ state, onClose, onMarkerClick }: ITkPanelViewProps) {
  const isReady = state.status === 'ready';
  const markers = isReady ? state.markers : [];
  const isIncomplete = isReady && state.missingCount > 0;

  return (
    <div className={styles['tk-panel']}>
      <div className={styles['tk-panel__header']}>
        <h4 className={styles['tk-panel__title']}>Метки TK</h4>

        {isReady && !isIncomplete && (
          <p className={styles['tk-panel__counter']}>
            {markers.length === 0 ? 'Ни одной не осталось' : `Осталось: ${markers.length}`}
          </p>
        )}

        <Button
          className={styles['tk-panel__close']}
          onClick={onClose}
          variant="shapeless"
          icon={<Close20 />}
          size="m"
        />
      </div>

      <div className={styles['tk-panel__body']}>
        {!isReady && <Spinner />}

        {isIncomplete && (
          <p className={styles['tk-panel__warning']}>
            Часть заметок не загрузилась, список неполный. Сколько меток осталось на самом деле —
            сейчас сказать нельзя.
          </p>
        )}

        {isReady && markers.length === 0 && !isIncomplete && (
          <p className={styles['tk-panel__message']}>Меток нет — здесь всё дописано.</p>
        )}

        {markers.length > 0 && (
          <div className={styles['tk-panel__list']}>
            {markers.map((marker) => (
              <button
                type="button"
                className={styles['tk-panel__item']}
                key={`${marker.noteId}-${marker.ordinal}`}
                onClick={() => onMarkerClick(marker)}
              >
                <span className={styles['tk-panel__item-note']}>{marker.noteName}</span>
                <span
                  className={classes(
                    styles['tk-panel__item-payload'],
                    marker.payload === '' && styles['tk-panel__item-payload_empty'],
                  )}
                >
                  {marker.payload === '' ? 'без описания' : marker.payload}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
